// extracted by mini-css-extract-plugin
module.exports = {"select":"select-input_select_28Y_v","option":"select-input_option_MVbVE"};